/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientModel } from '../../models/patient-model';

export interface ConsumerGet$Params {
  summary?: boolean;
}

export function consumerGet(http: HttpClient, rootUrl: string, params?: ConsumerGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<PatientModel>> {
  const rb = new RequestBuilder(rootUrl, consumerGet.PATH, 'get');
  if (params) {
    rb.query('summary', params.summary, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<PatientModel>;
    })
  );
}

consumerGet.PATH = '/Consumer';
